<template lang="pug">
.tabela
    el-table(
        :key="listagemTableKey('usuarios', usuarios, paginaLocal.page)",
        height='calc(100% - 57px)',
        :data='usuarios',
        @sort-change='ordenar'
    )
        el-table-column(
            prop='firstName',
            :label='$t("mensagens.usuarios.tabela.nome")',
            min-width='300',
            sortable
        )
            .template(slot-scope='scope')
                p.nome {{ `${scope.row.firstName || ''} ${scope.row.lastName || ''}` }}
                    em(v-if='scope.row.isAdmin') {{ $t('mensagens.usuarios.perfil.administrador') }}
                    em(v-else) {{ getRoleTraduzido(scope.row.role?.description) }}

        el-table-column(
            prop='email',
            :label='$t("mensagens.usuarios.tabela.email.label")',
            min-width='300'
        )
        el-table-column(
            prop='group',
            :label='$t("mensagens.usuarios.empresa")',
            min-width='200'
        )
        el-table-column(
            prop='enabled',
            :label='$t("mensagens.usuarios.tabela.email.statusLabel")',
            min-width='150'
        )
            .template(slot-scope='scope')
                div(
                    :class='[scope.row.requiredActions.length === 0 ? "verificado" : "nao-verificado"]'
                )
                    | {{ scope.row.requiredActions.length === 0 ? $t('mensagens.usuarios.tabela.email.statusVerificado') : $t('mensagens.usuarios.tabela.email.statusNaoVerificado') }}

        el-table-column(
            prop='enabled',
            :label='$t("mensagens.usuarios.tabela.statusUsuario.label")',
            min-width='150'
        )
            .template(slot-scope='scope')
                div(:class='[scope.row.enabled ? "ativo" : "inativo"]')
                    | {{ scope.row.enabled ? $t('mensagens.usuarios.tabela.statusUsuario.ativo') : $t('mensagens.usuarios.tabela.statusUsuario.inativo') }}

        el-table-column(
            min-width='100',
            align='center',
            :label='$t("mensagens.usuarios.tabela.acoes.label")'
        )
            .template(slot-scope='scope')
                el-dropdown.acoes(trigger='click')
                    span.el-dropdown-link
                        i.mdi.mdi-dots-vertical

                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-edit',
                            @click.native='abrirModalEditarUsuario(scope.row)'
                        )
                            | {{ $t('mensagens.usuarios.tabela.acoes.editar') }}

                        el-dropdown-item(
                            v-if='scope.row.enabled',
                            icon='el-icon-s-promotion',
                            @click.native='reenviarEmail(scope.row)'
                        )
                            | {{ $t('mensagens.usuarios.tabela.acoes.emailAcesso') }}

                        el-dropdown-item(
                            :icon='scope.row.enabled ? "el-icon-remove-outline" : "el-icon-circle-check"',
                            @click.native='acaoAlterarStatus(scope.row)'
                        )
                            | {{ scope.row.enabled ? $t('mensagens.usuarios.tabela.acoes.desativar') : $t('mensagens.usuarios.tabela.acoes.ativar') }}

        template(slot='empty')
            el-empty(
                :description='$t("mensagens.usuarios.emptyTemplate")'
            )

    .py-3.btn-paginacao(style='text-align: center')
        el-pagination(
            background,
            :page-size='20',
            :current-page.sync='paginaLocal.page',
            layout='prev, pager, next',
            :total='totalUsuarios',
            @current-change='onPageChange'
        )
</template>

<script>
export default {
    name: 'TabelaUsuarios',
    props: {
        usuarios: {
            type: Array,
            default: () => []
        },
        totalUsuarios: {
            type: Number,
            default: 0
        },
        pagina: {
            type: Object,
            default: () => ({ page: 1, filter: '' })
        }
    },
    data() {
        return {
            paginaLocal: { ...this.pagina }
        };
    },
    watch: {
        pagina: {
            handler(newVal) {
                this.paginaLocal = { ...newVal };
            },
            deep: true
        }
    },
    methods: {
        ordenar(sortInfo) {
            this.$emit('ordenar', sortInfo);
        },
        abrirModalEditarUsuario(usuario) {
            this.$emit('abrirModalEditarUsuario', usuario);
        },
        reenviarEmail(usuario) {
            this.$emit('reenviarEmail', usuario);
        },
        acaoAlterarStatus(usuario) {
            this.$emit('acaoAlterarStatus', usuario);
        },
        onPageChange(page) {
            this.paginaLocal.page = page;
            this.$emit('changePage', page);
        },
        getRoleTraduzido(role) {
            if (role != null) {
                switch (role) {
                    case 'Gestor':
                        return this.$t('mensagens.usuarios.perfil.gestor');
                    case 'Regular':
                        return this.$t('mensagens.usuarios.perfil.regular');
                    case 'Administrador':
                        return this.$t('mensagens.usuarios.perfil.administrador');
                    case 'Assistente':
                        return this.$t('mensagens.usuarios.perfil.assistente');
                    default:
                        return role;
                }
            }
            return '';
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    border-radius: 5px;
    overflow: hidden;
    background-color: var(--white);
    height: calc(100vh - 258px);
    width: 100%;
    padding-top: 0 !important;
    padding-bottom: 0 !important;

    .acoes:hover {
        cursor: pointer;
    }
}

.nome {
    em {
        font-size: 12px;
        background-color: #d1ead2;
        border: 1px solid #bae0bc;
        border-radius: 4px;
        padding: 0 4px;
        margin-left: 8px;
    }
}

.verificado,
.nao-verificado,
.ativo,
.inativo {
    border-radius: 20px;
    text-align: center;
    max-width: 120px;
    color: var(--black);
}

.verificado,
.ativo {
    background-color: #d1ead2;
    border: 1px solid #bae0bc;
}

.nao-verificado,
.inativo {
    background-color: #ffaeae;
    border: 1px solid var(--danger);
}

.pagination {
    background-color: var(--white);
    border-radius: 0 0 2px 2px;
    justify-content: center;
}
</style>
